import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import Button, { ButtonStyles, ButtonTypes } from 'components/layout/Button';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPagePasswordResetPasswordChanged: FunctionComponent<Props> = ({ translations }) => {
    const router = useRouter();

    return (
        <StyledComponent
            className="public-page-password-reset-password-changed"
        >
            <LayoutContainer size={Sizes.ExtraSmall}>
                <div className="content-container">
                    <header className="header">
                        <img
                            className="icon"
                            src="/images/job/job/check.svg"
                            alt=""
                            aria-hidden="true"
                            loading="lazy"
                        />
                        <h2
                            className="headline"
                            dangerouslySetInnerHTML={{ __html: translations?.headline }}
                        />
                    </header>
                    <Button
                        type={ButtonTypes.Button}
                        style={ButtonStyles.Primary}
                        className="submit-button"
                        onClick={() => router.push({
                            pathname: Routes.PublicHome,
                        })}
                    >
                        {translations?.buttonLabel}
                    </Button>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPagePasswordResetPasswordChanged;